import { Model, type ModelProps } from '@/infra/model'
import { computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'
import { toStream } from '@/utils/mobx-util'

/**
 * Props for {@link BusinessInfoSupportingItemInput}.
 */
export type BusinessInfoSupportingItemInputProps =
  ModelProps<BusinessInfoSupportingItemInput> & { type: 'BusinessInfo' }

/**
 * Supporting item input for business information.
 */
export class BusinessInfoSupportingItemInput
  extends Model<BusinessInfoSupportingItemInput>
  implements SupportingItemInputBase
{
  /**
   * The provided business profile, if any.
   */
  @observable.struct accessor provided: ProvidedBusinessProfile | null = null

  /**
   * Stream of changes to the provided business profile.
   */
  readonly providedChanges$ = toStream(() => this.provided)

  /** @inheritDoc */
  @computed get isCompleted() {
    return !!this.provided
  }
}

/**
 * A provided business profile.
 */
export interface ProvidedBusinessProfile {
  readonly profileId: string
  readonly profileVersion: number
}
